/* ajax-cart-hd.js — capa Ajax Cart global de HealthDose.
   Cargar UNA vez en layout/theme.liquid: <script src="..." defer>

   Qué hace:
   - Intercepta (por delegación) el submit de cualquier form con clase
     .hd-ajax-form y lo envía a /cart/add.js sin recargar.
   - Tras cada mutación pide /cart.js y publica el evento custom
     `hd:cart:updated` con el cart JSON en detail. Cualquier sección
     (shipbar, contador del header, drawer futuro) se suscribe a ese
     evento; ninguna sección conoce a otra.
   - Expone window.HDCart.addItems(items) para añadidos múltiples
     (bundle builder).

   Qué NO hace: abrir un cart drawer. Si el tema base tiene drawer
   propio, engánchalo escuchando hd:cart:updated. */

(function () {
  'use strict';

  // Config opcional desde el layout:
  //   window.HD_CART_REDIRECT = true   -> tras añadir, ir a /cart
  //   (red de seguridad si el tema base no refresca su drawer solo)

  async function refreshCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();

    // 1) Nuestro evento: shipbar, contador HD, etc.
    document.dispatchEvent(new CustomEvent('hd:cart:updated', { detail: { cart } }));

    // 2) Refrescar el contenido del drawer con la Section Rendering API,
    //    y disparar los eventos que este tema (Web Components) escucha
    //    para re-hidratar sus componentes de carrito.
    await refreshDrawerSections();

    // 3) Eventos estándar + los de este tema. Publish de Shopify y un
    //    evento 'cart:update' que los <cart-items-component> observan.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hd', cart: cart }); } catch (e) {}
    }

    updateCount(cart.item_count);

    // 4) Abrir el drawer existente (o, si se pidió, ir a /cart).
    if (window.HD_CART_REDIRECT === true) {
      window.location.href = '/cart';
    } else {
      openDrawer();
    }
    return cart;
  }

  // Pide a Shopify el HTML actualizado de las secciones del drawer y las
  // reemplaza en el DOM. Cubre los IDs de sección más comunes (Dawn:
  // 'cart-drawer' y 'cart-icon-bubble'); añade los tuyos en
  // window.HD_CART_SECTIONS si tu tema usa otros.
  async function refreshDrawerSections() {
    var ids = (window.HD_CART_SECTIONS || []).concat(['cart-drawer-section']);
    try {
      var url = '/?sections=' + ids.join(',');
      var data = await fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      ids.forEach(function (id) {
        if (!data[id]) return;
        var doc = new DOMParser().parseFromString(data[id], 'text/html');
        var incoming = doc.querySelector('#shopify-section-' + id) || doc.body.firstElementChild;
        var current = document.getElementById('shopify-section-' + id);
        if (incoming && current) { current.innerHTML = incoming.innerHTML; }
      });
    } catch (e) { /* si falla, el drawer se abrirá con su estado previo */ }
  }

  // Abre el drawer de este tema (<theme-drawer id="cart-drawer">).
  function openDrawer() {
    // Si ya está abierto (p. ej. añadido desde el cross-sell interno),
    // no tocar nada: el toggle del header lo CERRARÍA.
    var dlg = document.querySelector('#cart-drawer dialog');
    if (dlg && dlg.open) return true;

    // 1) La vía más fiable: disparar el clic del botón de la bolsa del
    //    header. Ese botón ya abre el drawer con el mecanismo nativo
    //    del tema (bus on:click), así que replicamos su flujo exacto.
    //    Este tema usa atributos on:click="#cart-drawer/...".
    var withHandler =
      document.querySelector('[on\\:click*="#cart-drawer"]:not(.theme-drawer__close-button)') ||
      document.querySelector('button[aria-controls="cart-drawer"]');
    if (withHandler) { withHandler.click(); return true; }

    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      // 2) API propia del custom element si la expone.
      if (typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return true; } catch (e) {} }
      if (typeof drawer.open === 'function') { try { drawer.open(); return true; } catch (e) {} }
      if (typeof drawer.show === 'function') { try { drawer.show(); return true; } catch (e) {} }
      // 3) Forzar atributo open en <theme-drawer> y su <dialog>.
      drawer.setAttribute('open', '');
      var dialog = drawer.querySelector('dialog');
      if (dialog && !dialog.open) {
        try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
      }
      document.body.classList.add('overflow-hidden');
      return true;
    }
    // 4) Si el toggle era un enlace (no botón), NO lo clicamos para no
    //    navegar; respaldo visual.
    showToast();
    return false;
  }

  function updateCount(count) {
    var text = String(count);

    // Estructura de ESTE tema (del inspector): para mostrar el número
    // hay que replicar 3 cambios — clase --has-cart en <cart-icon>,
    // quitar visually-hidden de .cart-bubble y quitar hidden del count.
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      var bubble = icon.querySelector('.cart-bubble');
      var num = icon.querySelector('.cart-bubble__text-count');
      if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
      if (num) {
        num.textContent = text;
        num.classList.toggle('hidden', count === 0);
      }
    });

    // Badge de dentro del drawer + selectores genéricos de respaldo.
    var selectors = (window.HD_CART_COUNT_SELECTORS || []).concat([
      '.theme-drawer__badge',
      '[data-cart-count]', '.cart-count', '.header__cart-count'
    ]);
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = text;
      });
    });
  }

  function showToast(count) {
    var t = document.getElementById('hd-cart-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'hd-cart-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML =
        '<span class="hd-cart-toast__msg"></span>' +
        '<a class="hd-cart-toast__link" href="/cart"></a>';
      document.body.appendChild(t);
    }
    var addedTpl = t.dataset.added || 'Added to cart';
    var viewTpl = t.dataset.view || 'View cart';
    t.querySelector('.hd-cart-toast__msg').textContent = addedTpl;
    var link = t.querySelector('.hd-cart-toast__link');
    link.textContent = count ? viewTpl + ' (' + count + ')' : viewTpl;
    t.classList.add('is-on');
    clearTimeout(t._hide);
    t._hide = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }

  window.HDCartUI = { showToast: showToast, updateCount: updateCount };

  /* ---- Cierre del drawer: clic fuera, enlaces internos y Escape ----
     Al forzar el modo overlay, la mecánica de clic-fuera del tema quedó
     desconectada. Cerramos siempre vía SU botón de cierre (flujo nativo,
     con su animación), nunca forzando el dialog. */
  function closeDrawer() {
    var btn = document.querySelector('#cart-drawer .theme-drawer__close-button');
    if (btn) { btn.click(); return true; }
    var dlg = document.querySelector('#cart-drawer dialog');
    if (dlg && dlg.open) { try { dlg.close(); } catch (e) {} }
    return false;
  }

  document.addEventListener('click', function (e) {
    var dlg = document.querySelector('#cart-drawer dialog');
    if (!dlg || !dlg.open) return;

    var insideDialog = e.target.closest('#cart-drawer dialog');
    if (insideDialog) {
      // Enlace dentro del drawer (Continue shopping, CTA del bundle,
      // título de un producto…): cerrar y dejar navegar. Cubre también
      // anclas en la misma página (/#bundle), donde no hay recarga.
      if (e.target.closest('a[href]')) closeDrawer();
      return;
    }
    // El toggle del header gestiona su propio abrir/cerrar.
    if (e.target.closest('[on\\:click*="#cart-drawer"]')) return;

    // Clic fuera: cerrar y tragarse el clic para no activar lo que
    // hubiera debajo (un enlace de la página, un botón…).
    e.preventDefault();
    e.stopPropagation();
    closeDrawer();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var dlg = document.querySelector('#cart-drawer dialog');
    if (dlg && dlg.open) closeDrawer();
  });

  /* ---- Cross-sell del drawer: añadido rápido ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hd-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.variantId, 10);
    if (!Number.isInteger(id) || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    var done = function () { btn.setAttribute('aria-disabled', 'false'); };
    if (window.HDCart && typeof window.HDCart.addItems === 'function') {
      window.HDCart.addItems([{ id: id, quantity: 1 }]).then(done, done);
    } else {
      done();
    }
  });

  /* ---- Shipbar mini del drawer: actualización instantánea ----
     El tema re-renderiza el drawer por Section Rendering (valores
     frescos del servidor), pero eso tarda unos ms; este listener pinta
     el estado al instante para que no haya salto visual. */
  document.addEventListener('hd:cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    document.querySelectorAll('[data-hd-shipmini]').forEach(function (el) {
      var th = parseInt(el.dataset.threshold, 10) || 0;
      if (!th) return;
      var remaining = th - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / th) * 100));
      var fill = el.querySelector('[data-shipmini-fill]');
      var msg = el.querySelector('[data-shipmini-msg]');
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (remaining > 0) {
          var fmt = el.dataset.moneyFormat || 'AED {{amount}}';
          var amount = fmt.replace(/\{\{\s*amount[^}]*\}\}/g, (remaining / 100).toFixed(2));
          msg.textContent = (el.dataset.tplRemaining || 'Only [amount] to free delivery')
            .replace('[amount]', amount);
        } else {
          msg.textContent = el.dataset.tplDone || 'Free delivery unlocked';
        }
      }
    });
  });

  /* ---- Observador de mutaciones del carrito ----
     El drawer del tema base elimina/actualiza artículos con su propia
     lógica y NUNCA emite nuestros eventos, así que la shipbar y el
     contador se quedaban con datos viejos al borrar o vaciar.
     Envolvemos fetch: cualquier llamada a los endpoints de mutación del
     carrito (venga de quien venga) dispara una sincronización.
     /cart.js (solo lectura) queda fuera para no crear bucles. */
  var MUTATING = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _origFetch = window.fetch;
  var _syncTimer = null;

  function syncFromCart() {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function () {
      _origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('hd:cart:updated', { detail: { cart: cart } }));
          updateCount(cart.item_count);
        })
        .catch(function () { /* red caída: siguiente mutación reintenta */ });
    }, 150); // debounce: agrupa ráfagas (p.ej. cambiar cantidad rápido)
  }

  window.fetch = function () {
    var url = typeof arguments[0] === 'string'
      ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    var p = _origFetch.apply(this, arguments);
    if (MUTATING.test(url)) {
      p.then(function (res) { if (res && res.ok) syncFromCart(); })
       .catch(function () {});
    }
    return p;
  };

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Add to cart failed');
    }
    return refreshCart();
  }

  window.HDCart = { addItems, refreshCart };

  // Construye el item desde el FormData COMPLETO del form: id, quantity,
  // selling_plan y properties[...]. Los inputs disabled no viajan (FormData
  // los excluye), así que la compra única nunca manda selling_plan vacío.
  function itemFromForm(form) {
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    if (!id) return null;

    const item = { id, quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };

    const plan = fd.get('selling_plan');
    if (plan) item.selling_plan = Number(plan);

    const props = {};
    for (const [key, value] of fd.entries()) {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m && value !== '') props[m[1]] = value;
    }
    if (Object.keys(props).length) item.properties = props;

    return item;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.hd-ajax-form');
    if (!form) return;
    e.preventDefault();

    const item = itemFromForm(form);
    if (!item) return;

    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      await addItems([item]);
      if (btn) btn.textContent = btn.dataset.addedLabel || 'Added ✓';
    } catch (err) {
      if (btn) btn.textContent = btn.dataset.errorLabel || 'Error';
      console.error('[HDCart]', err);
    } finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1600);
    }
  });
})();